import styled from "styled-components";

export const P = styled.p`
  font-size: 2rem;
  color: #464646;
`;